<template>
    <div>
        <material-card color="green" class="payment-methods-card">
            <v-flex slot="header">
                <v-layout row>
                    <span
                        class="title font-weight-light mb-2"
                        style="align-self: center"
                        >Payment Methods ({{ paymentMethods.length }})</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        style="color: #4caf50; background-color: #FFF; height: 28px; margin-top: 6px !important;"
                        class="ma-0"
                        small
                        @click="openNewPaymentMethodDialog()"
                        >Add
                    </v-btn>
                    <v-btn
                        @click="toggleExpansion"
                        flat
                        icon
                        class="ma-0"
                        color="#fff"
                    >
                        <v-icon>{{
                            expanded
                                ? "mdi-minus-circle-outline"
                                : "mdi-plus-circle-outline"
                        }}</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
            <div v-if="expanded">
                <div
                    v-if="paymentMethods.length"
                    style="overflow-y: auto; max-height: 200px;"
                >
                    <div v-for="(method, index) in paymentMethods">
                        <v-layout row justify-space-between class="mx-3 mb-0">
                            <v-layout row class="mt-2">
                                <div
                                    class="mt-3"
                                    v-bind:class="{
                                        'my-3': method.type != 'CC',
                                    }"
                                >
                                    {{ method.cardInfo }}
                                </div>
                                <div
                                    class="ml-2 mt-3"
                                    v-if="method.type == 'CC'"
                                >
                                    •
                                </div>
                                <v-layout
                                    class="mt-3 ml-2"
                                    row
                                    v-if="
                                        !method.editing && method.type == 'CC'
                                    "
                                >
                                    <div>Exp. Date:</div>
                                    <div class="ml-1">
                                        {{
                                            getExpirationDateDisplay(
                                                method.expirationDate
                                            )
                                        }}
                                    </div>
                                </v-layout>
                                <v-text-field
                                    class="ml-2"
                                    v-if="method.editing"
                                    style="max-width: 20%;"
                                    label="Exp. Date"
                                    placeholder="Exp. Date"
                                    ref="expDate"
                                    :mask="expDateMask"
                                    :rules="expDateRules"
                                    v-model="method.expirationDate"
                                ></v-text-field>
                                <v-text-field
                                    class="ml-2"
                                    v-if="method.editing"
                                    style="max-width: 20%;"
                                    label="CVV"
                                    placeholder="CVV"
                                    ref="cvv"
                                    :mask="cvvMask"
                                    v-model="method.cvv"
                                ></v-text-field>
                            </v-layout>
                            <v-btn
                                v-if="!method.editing && method.type == 'CC'"
                                @click="editExpiration(method)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                v-if="!method.editing"
                                @click="removeMethod(method)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout column class="mx-0 mb-2">
                            <button
                                class="view-card-button"
                                @click="showCardNumber(method)"
                            >
                                {{
                                    method.cardNumber
                                        ? "Hide Card Number"
                                        : "View Card Number"
                                }}
                            </button>
                            <div class="mt-2">{{ method.cardNumber }}</div>
                        </v-layout>
                        <v-layout row class="my-3 mr-4" v-if="method.editing">
                            <v-layout row>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="small-button mr-1"
                                    color="default"
                                    @click="rollbackEditExpiration(method)"
                                    small
                                    dark
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    class="small-button"
                                    color="success"
                                    small
                                    @click="save(method)"
                                    >Save</v-btn
                                >
                            </v-layout>
                        </v-layout>
                        <v-divider
                            class="my-1"
                            v-if="index + 1 < paymentMethods.length"
                        ></v-divider>
                    </div>
                </div>
                <div v-if="!paymentMethods.length" class="mt-2 text-xs-center">
                    No Payment Methods
                </div>
            </div>
        </material-card>
        <v-dialog v-model="removeMethodDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Delete Card</v-card-title
                >
                <v-card-text class="mb-0 pt-0">
                    This will delete the
                    {{ methodToDelete.type ? " card " : " bank account " }}
                    ending in {{ " " + methodToDelete.cardNumberLast5 }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="removeMethodDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="deleteMethod"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="reloadPage"
                :hideBankAccount="false"
            ></new-payment-method>
        </v-dialog>
    </div>
</template>
<script>
import cardValidator from "card-validator";
import newPaymentMethod from "../Payment/NewPaymentMethod.vue";

export default {
    props: {
        paymentMethods: Array,
        reloadPage: Function,
        accountID: String,
    },
    components: {
        newPaymentMethod,
    },
    data() {
        return {
            expanded: false,

            expDateMask: "##/##",
            cvvMask: "####",

            processing: false,
            removeMethodDialog: false,
            methodToDelete: "",
            newPaymentMethodDialog: false,

            expDateRules: [
                (v) => !!v || "Required",
                (v) =>
                    (v && this.validateExpDate(v)) ||
                    "A valid 4 digit expiration date required",
            ],
        };
    },
    async created() {},
    computed: {},
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
        openNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = true;
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        getExpirationDateDisplay(expDate) {
            if (!expDate) return "";

            return expDate.substring(0, 2) + "/" + expDate.substring(2, 4);
        },
        validateExpDate(expDate) {
            const date = expDate.replace("/", "");

            if (date.length > 4) return false;

            return cardValidator.expirationDate(expDate).isValid;
        },
        editExpiration(method) {
            method.editing = true;
            method.original = method.expirationDate;
        },
        removeMethod(method) {
            this.methodToDelete = method;
            this.removeMethodDialog = true;
        },
        async deleteMethod(method) {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/payments/deletePaymentMethod?paymentMethodID=" +
                        this.methodToDelete.id
                );

                this.processing = false;
                this.removeMethodDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Payment Method Deleted",
                    type: "success",
                });

                this.reloadPage();
            } catch (e) {
                this.processing = false;
            }
        },
        rollbackEditExpiration(method) {
            method.expirationDate = method.original;
            method.editing = false;
        },
        async showCardNumber(method) {
            try {
                if (method.cardNumber) {
                    method.cardNumber = "";

                    return;
                }

                const cardNumber = await this.$http.get(
                    "api/payments/getCardNumber?paymentMethodID=" + method.id
                );

                method.cardNumber = cardNumber;
            } catch (e) {}
        },
        async save(method) {
            const index = this.paymentMethods
                .filter((m) => m.editing)
                .indexOf(method);

            if (!this.$refs.expDate[index].validate(true)) return;

            try {
                method.processing = true;

                await this.saveNewExpiration(method);
                await this.saveNewCVV(method);

                method.processing = false;
                method.editing = false;
            } catch (e) {
                method.processing = false;
            }
        },
        async saveNewExpiration(method) {
            await this.$http.post(
                "api/payments/updatePaymentMethodExpiration",
                {
                    id: method.id,
                    expiration: method.expirationDate,
                }
            );
        },
        async saveNewCVV(method) {
            await this.$http.post("api/payments/updateCVV", {
                id: method.id,
                cvv: method.cvv,
            });
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
.payment-methods-card .v-card--material__header.v-card {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
.view-card-button {
    background: none !important;
    border: none;
    padding: 0 !important;
    padding-left: 4px !important;
    font-size: 14px;
    width: fit-content;
    margin-top: 0px;
    /*optional*/
    font-family: arial, sans-serif;
    /*input has OS specific font-family*/
    color: rgb(32, 166, 237);
    text-decoration: underline;
    cursor: pointer;
}
</style>
